// extracted by mini-css-extract-plugin
export default {"container":"Dot_container__tpKQr"};